import React from 'react';
import Icon from './Icon';

const KIND_STYLES = {
  primary: {
    background: 'var(--ab-fg)',
    color: 'var(--ab-fg-inverse)',
    border: '1px solid var(--ab-fg)',
  },
  secondary: {
    background: 'var(--ab-bg)',
    color: 'var(--ab-fg)',
    border: '1px solid var(--ab-fg)',
  },
  ghost: {
    background: 'transparent',
    color: 'var(--ab-fg)',
    border: '1px solid transparent',
  },
  danger: {
    background: 'var(--ab-denied)',
    color: 'var(--ab-fg-inverse)',
    border: '1px solid var(--ab-denied)',
  },
};

const SIZE_STYLES = {
  sm: { padding: '4px 10px', fontSize: 12, height: 28 },
  md: { padding: '6px 14px', fontSize: 13, height: 34 },
  lg: { padding: '8px 18px', fontSize: 14, height: 40 },
};

/**
 * @param {{
 *   kind?: 'primary'|'secondary'|'ghost'|'danger',
 *   size?: 'sm'|'md'|'lg',
 *   icon?: string,
 *   iconRight?: string,
 *   disabled?: boolean,
 *   onClick?: (e: any) => void,
 *   type?: 'button'|'submit',
 *   children?: any,
 *   className?: string,
 *   style?: React.CSSProperties,
 * }} props
 */
export default function Btn({
  kind = 'secondary',
  size = 'md',
  icon,
  iconRight,
  disabled = false,
  onClick,
  type = 'button',
  children,
  className: callerClassName,
  style: callerStyle,
  ...rest
}) {
  const kindStyle = KIND_STYLES[kind] || KIND_STYLES.secondary;
  const sizeStyle = SIZE_STYLES[size] || SIZE_STYLES.md;
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`ab-btn${callerClassName ? ' ' + callerClassName : ''}`}
      style={{
        ...kindStyle,
        ...sizeStyle,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        borderRadius: 'var(--ab-radius-sm)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.55 : 1,
        fontWeight: 'var(--ab-weight-semi)',
        whiteSpace: 'nowrap',
        ...callerStyle,
      }}
      {...rest}
    >
      {icon && <Icon name={icon} size={size === 'sm' ? 12 : 14} />}
      {children}
      {iconRight && <Icon name={iconRight} size={size === 'sm' ? 12 : 14} />}
    </button>
  );
}
